module.exports = __webpack_public_path__ + "media/images/tailwind/calendar-2e479d768851dd57b92fa326e6f971bd.png";